<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <div>
        <p class="step-counter tablet">1 de 2</p>
        <wrap-container class="cascade w50">
          <form-validator>
            <wrap-container>
              <p
                id="titulo"
                class="titulo p32 medium oscuro"
                v-safe-html="config.pasos.sucursal.titulo"
              />
              <p
                id="subtitulo"
                class="te-pedimos"
                v-safe-html="config.pasos.sucursal.subtitulo"
              />
            </wrap-container>
            <wrap-container class="sucursal">
              <branch-offices-old
                v-model="model.sucursal"
                :required="true"
                name="sucursal"
                quantumObfuscate
              />
            </wrap-container>
            <wrap-container class="sucursal">
              <div class="info">
                <span class="text-info">
                  <img
                    class="error-img"
                    src="@/assets/img/1x/0info_icon.png"
                    alt="Ícono error"
                  />
                  <p>Verificá que tu CUIL sea el correcto o corregilo:</p>
                </span>
                <cuil-input
                  class="col2"
                  v-model="model.cuil"
                  name="cuil"
                  label="Ingresá cuil"
                  hint="Ingresá cuil"
                  :required="true"
                  maxlength="11"
                  quantumObfuscate
                />
              </div>
            </wrap-container>
            <div class="sn-mobile">
              <step-navigator
                v-model="model"
                :store-action="this.doNext"
                analyticsName="finalizar"
              />
            </div>
          </form-validator>
        </wrap-container>
        <wrap-container class="cascade w50"></wrap-container>
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import BranchOfficesOld from "@/components/core/composite/combos/BranchOfficesOld";
import StepNavigator from "@/components/core/StepNavigator";
import CuilInput from "@/components/core/composite/CuilInput";
import { DO_SUCURSAL } from "../config/constants/action-types";
import { cuilGen } from "@/utils";

export default {
  name: "Sucursal",
  components: {
    WrapContainer,
    FormValidator,
    BranchOfficesOld,
    StepNavigator,
    CuilInput
  },
  mounted() {
    if (this.$store.getters.getSucursal().cuil === "") {
      this.$store.getters.getSucursal().cuil = cuilGen(
        this.$store.getters.getConsulta().numeroDoc,
        this.$store.getters.getConsulta().sexo
      );
    }
  },
  data() {
    return {
      model: this.$store.getters.getSucursal(),
      doNext: DO_SUCURSAL
    };
  }
};
</script>

<style scoped>
.step-counter {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: -0.3px;
  color: #666666;
  margin-bottom: 0px;
}

.te-pedimos {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
  max-width: 500px;
  margin-top: -20px;
  margin-bottom: 40px;
}

.sucursal {
  margin-bottom: 40px;
}

.info {
  background-color: #ceecfd;
  padding: 24px;
}

.text-info {
  display: flex;
  align-items: center;
}

.error-img {
  margin-right: 8px;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }

  .sn-mobile {
    max-width: 600px;
    width: 100%;
    bottom: 0;
    margin-right: 50px;
    padding-right: 35px;
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 10%;
  }
}
</style>
